import { SCROLL_TO_EVENT, useResponseEmitterSubscription } from "queues/ResponsesEmitter";
import { usePostWrapperHookOptions, scrollIntoView } from "lib-core"

export const usePostWrapperHook = ({ postId, numbering, elementRef, setCounter }: usePostWrapperHookOptions) => {
  useResponseEmitterSubscription(SCROLL_TO_EVENT, (e) => {
    if (e.postId !== postId) {
      if (!e.numbering || !numbering || e.numbering.length !== numbering.length) {
        return;
      }
      for (let i = 0; i < numbering.length; i++) {
        if (numbering[i] !== e.numbering[i]) {
          return;
        }
      }
    }

    if (elementRef.current) {
      scrollIntoView(elementRef.current);
      setCounter(v => v + 1);
    }
  }, [postId, numbering]);
};
